"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _secutixObjects = require("@gravity/secutix-objects");
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/SimplePrice.js",
  _templateObject,
  _this = void 0;
function cov_40s6wgil8() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/SimplePrice.js";
  var hash = "c0d8069cbe08dffc9f3c0582d3d15ecac55d8685";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/SimplePrice.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 9,
          column: 4
        }
      },
      "1": {
        start: {
          line: 14,
          column: 20
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 17,
          column: 12
        }
      },
      "3": {
        start: {
          line: 20,
          column: 0
        },
        end: {
          line: 25,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 21
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 12
          }
        },
        line: 15
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c0d8069cbe08dffc9f3c0582d3d15ecac55d8685"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_40s6wgil8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_40s6wgil8();
var Wrapper = (cov_40s6wgil8().s[0]++, _styledComponents.default.span.attrs({
  className: 'g-Price'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)([""]))));

/*
 * Component to display the amount and the currency of a PriceType.
 */
cov_40s6wgil8().s[1]++;
var SimplePrice = function SimplePrice(_ref) {
  var price = _ref.price;
  cov_40s6wgil8().f[0]++;
  cov_40s6wgil8().s[2]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedNumber, {
    value: price.amount / 1000,
    style: "currency",
    currency: price.currencyCode,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }));
};
cov_40s6wgil8().s[3]++;
SimplePrice.propTypes = {
  /**
   * The price object we want to display
   */
  price: _secutixObjects.PriceType.isRequired
};
var _default = exports.default = SimplePrice;